import { SET_CURRENT_USER } from  '../actions/types';
import isEmpty from '../../validation/is-empty';

const initialState = {
    isAuthenticated: false,
    currentUser: {}
}

export default function(state = initialState, action) {
    switch(action.type) {
        case SET_CURRENT_USER:
            return{
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                currentUser: action.payload
            }
        default: 
            return state;
    }
} 


// export default function(state = initialState, action) { 
//     switch (action.type) {
//         default:
//             return state;
//     }
// }


//isAutheticated